module.exports = __webpack_public_path__ + "files/06f2f77da943b22ac34979660eba841c.png";